import React, { Component } from 'react';
import { Popover, ArrowContainer } from 'react-tiny-popover';
import './ImagePopOver.scss';
import ImgTag from '../ImgTag';
import addButtonWhite from '../../../../assets/icons/ic_add_blue.png';
import menuDeleteIcon from '../../../../assets/icons/ic_delete_lite_grey.png';
import attachImage from '../../../../assets/icons/ic_attachment.png';
import Button from '../Button';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { updateBotValue, successGenericDataGet, blockUiFun, reloginUser } from '../../../Redux/Actions/uiActions';
import { upload } from '../../../Utils/index';
class ImagePopOver extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isGeneric: false,
            popoverObj: false,
            isOpen: false,
            groupDesc: 'Please attach an image which is Min. 36 x 36 px and Max. 72 x 72 px with 72 DPI, in jpg/jpeg/svg/png format only'
        }
    }

    componentDidMount() {
        const firstParam = this.props.location.pathname.split('/')[1];
        if (firstParam === 'genericconfig' && !this.state.isGeneric) {
            this.setState({ isGeneric: true })
        } else if (this.state.isGeneric) {
            this.setState({ isGeneric: false })
        }
    }

    addButton = (imageSrc) => {
        return (
            <span className='eb-icon-btn-image'>
                <ImgTag
                    className='image'
                    src={imageSrc}
                    alt='Add'
                />
            </span>
        );
    }

    imageUploadValidation = (e) => {
        window.URL = window.URL || window.webkitURL;
        let that = this;
        const botId = window.localStorage.getItem('bot_id');
        e.preventDefault();
        let files = e.currentTarget.files;

        let formData = new FormData();
        for (var i = 0; i < files.length; i++) {
            formData.append('file', files[i]);

            const idxDot = files[i].name.lastIndexOf(".") + 1;
            const extFile = files[i].name.substr(idxDot, files[i].name.length).toLowerCase();
            if (extFile == "jpg" || extFile == "jpeg" || extFile == "png" || extFile == "svg") {

            } else {
                alert("Only jpg/jpeg/svg/png file types are allowed");
                return false;
            }
        }
        formData.append('botId', botId);

        if (files.length) {
            that.props.blockUiFun(true);
            let img = new Image();
            img.src = window.URL.createObjectURL(files[0]);
            img.onload = function () {
                let width = img.naturalWidth,
                    height = img.naturalHeight;

                window.URL.revokeObjectURL(img.src);
                if (width <= 72 && height <= 72 && width >= 36 && height >= 36) {
                    upload(files, false, (reponseUrl) => {
                        that.props.onUplaod(e, reponseUrl);
                        that.setState({ popoverObj: !that.state.popoverObj });
                        that.props.blockUiFun(false);
                    }, (err) => {
                        if (err && err.status && err.status === 401) {
                            that.props.reloginUser();
                        }
                        that.setState({ popoverObj: !that.state.popoverObj });
                        that.props.blockUiFun(false);
                    });
                }
                else {
                    that.props.blockUiFun(false);
                    alert('Please upload file size in mentioned size');
                }
            };
        }
        else {
            console.log('file not found');
        }
    }

    render() {
        let ts = new Date().getTime();
        let tempId = parseInt(Math.random(10000) * 10000) + ts;
        return (
            <>
                <Popover
                    isOpen={this.state.popoverObj}
                    positions={['bottom', 'left', 'right']}
                    reposition={true}
                    padding={5}
                    margin={-15}
                    parentElement={document.getElementById('mainBodySection')}
                    onClickOutside={() => {
                        this.setState({ popoverObj: false })
                    }}
                    containerClassName='popover-menu-outer-wrapper image-popover-wrapper'
                    content={({ position, childRect, popoverRect }) => (
                        <div className='popover-wrapper popover-menu-wrapper popover-align-left'
                            onClick={() => {
                                this.setState({ popoverObj: !this.state.popoverObj });
                            }}
                        > <ArrowContainer
                            position={position}
                            childRect={childRect}
                            popoverRect={popoverRect}
                            arrowColor={"#fff"}
                            arrowSize={12}
                            arrowStyle={{ opacity: 1 }}
                        >
                                <div className='popover-block popover-image-block'>
                                    <p className='popover-description'>
                                        {this.state.groupDesc ? this.state.groupDesc : 'NA'}
                                    </p>
                                    <div className='config-value-info'>
                                        <label htmlFor={tempId} className='image-upload-label' onClick={(e) => {
                                            e.stopPropagation();
                                        }}>
                                            <img src={attachImage} alt='Attach Img' />
                                            Attach Image
                                            <span>Upload</span>
                                            <input id={tempId} type='file' accept="image/x-png, image/jpeg, image/svg" defaultValue={this.props.selectedVal ? this.props.selectedVal : ''} className='image-upload-input-field' onChange={this.imageUploadValidation} />
                                        </label>
                                    </div>
                                    <div className='icon-button-wrapper go-float-right'>
                                        <Button
                                            className='eb-icon-btn-style'
                                            type='button'
                                            title='Remove'
                                            value={this.addButton(menuDeleteIcon)}
                                            buttonOnClick={(e) => {
                                                this.props.onUplaod(e, '', true);
                                            }}
                                        />
                                    </div>
                                </div>
                            </ArrowContainer>
                        </div>
                    )}
                >
                    <button className='eb-icon-btn-style' type='button' title='Upload Image' onClick={(e) => { let tempa = this.props.imageUrl !== '' ? this.props.beforeImgUpdate(e, this.props.imageUrl) : null; this.setState({ popoverObj: !this.state.popoverObj }); }}>
                        <span className='eb-icon-btn-image'>
                            <ImgTag
                                className='image'
                                src={addButtonWhite}
                                alt='More'
                            />
                        </span>
                    </button>
                </Popover>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        editableBotData: state.UiReducer && state.UiReducer.editableBotData ? state.UiReducer.editableBotData : {},
        genericBotData: state.UiReducer && state.UiReducer.genericBotData ? state.UiReducer.genericBotData : {}
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        updateBotValue,
        successGenericDataGet,
        blockUiFun,
        reloginUser
    },
        dispatch
    );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ImagePopOver));